export default {
  loggedIn: false,
  loading: false,
  forgotPasswordLoading: false,
  forgotPasswordSuccess: false,
  resetPasswordLoading: false,
  resetPasswordSuccess: false
};
